const avisosFake = {
  aviso: {
    localizacion: 'Santiago de Chile, Región Metropolitana',
    idPais: 1007,
  },
}

export default avisosFake
